import React from 'react';
import { money, currencySymbol } from '../lib/constants';
import { useCurrencies } from '../context/CurrencyContext';

export const CurrencyBalances = ({ balances, prefix, hidden = false, className = '', currency: selectedCurrency }) => {
  const { codes } = useCurrencies();
  return <div className={`space-y-1 ${className}`}>
  {(selectedCurrency ? [selectedCurrency] : [...new Set([...codes, ...Object.keys(balances || {}).filter(code => Number(balances[code]) !== 0)])]).map(currency => <div key={currency} data-testid={`${prefix}-${currency.toLowerCase()}`} className="font-mono break-words">
    <span className="text-[.75em] opacity-75 mr-2">{currency}</span>{hidden ? '••••' : balances ? `${currencySymbol(currency)}${money(balances[currency])}` : '…'}
  </div>)}
</div>;
};